import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EtiquetaMascarelloComponent } from './etiqueta-mascarello.component';
import { BarcodeModule } from '../barcode/barcode.module';
import { QrCodeModule } from '../qr-code/qr-code.module';

@NgModule({
  declarations: [
    EtiquetaMascarelloComponent
  ],
  imports: [
    CommonModule,
    BarcodeModule,
    QrCodeModule
  ],
  exports: [
    EtiquetaMascarelloComponent
  ]
})
export class EtiquetaMascarelloModule { }
